
export const MASTER_SHEET_COLUMNS = [
  'Town Name',
  'SHOPNO.',
  'Auditor',
  'Auditor code',
  'Customer',
  'DT SAP ID (ZX)',
  'Distributor Name',
  'Company Code',
  'SUB REGION',
  'COOLER MODEL',
  'COOLER ASSET NO',
  'Cooler Serial No.',
  'RSM Name',
  'ASM Name',
  'SO/SE Name',
  'PS /DS SAP CODE',
  'PS/DS Name',
  'Outlet Channel',
  'Outlet Class',
  'Outlets Name',
  'Street',
  'DISTRICT BY MDC CODE',
  'TOWNCODE',
  'STORE ID',
  'City',
  'Remarks',
  'Tele No. 1',
  'Master Longitude',
  'Master Latitude',
  'Cooler Status',
  'REMARKS FOR VISICOOLER',
];

export const MASTER_SHEET_SAMPLE_ROW = [
  'Baglung',
  3130510003,
  'Sanad Kumar Shrestha',
  118,
  75018561,
  70000064,
  'AARJAN SUPPLIERS',
  'BNTL',
  'NORTH',
  'Visi Cooler 7 Caser',
  'T3243/12',
  'IN0200121764',
  'RSM-BISHAL SHRESTHA',
  'ASM-YUB RAJ GHIMIRE',
  'SO-SABIN RAUT',
  99002932,
  'ANIL SUBEDI',
  'E&D',
  'SILVER',
  'CHAUTARI RESTAURANT',
  'BAGLUNG',
  'BAGLUNG',
  31305,
  10003,
  'Baglung',
  'Regular',
  9847635327,
  0,
  0,
  'Visi Cooler 7 Caser',
  'Yes',
];